import React from 'react';
import { Page, StaticPage } from './components/Page/Page';
import { StrategySummary } from './components/StrategySummary/StrategySummary';
import ContactUsForm from './components/Forms/ContactUsForm/ContactUsForm';

import Content from './services/Content';
import { Navigate } from 'react-router-dom';

import { PlayerDashboard } from 'components/PlayerDashboard/PlayerDashboard';
import { Chapter } from 'components/Chapter/Chapter';
import { SupportServices } from 'components/SupportServices/SupportServices';
import { ChatMate } from 'components/ChatMate/ChatMate';
import { IS_CHAT_BOT_ENABLED } from './constants';

export interface IRoute {
  index?: boolean;
  path?: string;
  // render?: ({ match }: any) => JSX.Element;
  elem: JSX.Element;
}

/********** Route setup (based on authenticated status) ********/
export const getRoutes = (): IRoute[] => {
  // All users can access these routes
  const routes: IRoute[] = [
   
    { path: '/terms-and-conditions', elem: <StaticPage pageIdentifier="terms-and-conditions" /> },
    { path: '/collection-notice', elem: <StaticPage pageIdentifier="collection-statement" /> },
    { path: '/collection-statement', elem: <StaticPage pageIdentifier="collection-statement" /> },
    {
      path: '/contact-us',
      elem: (
        <Page>
          <ContactUsForm />
        </Page>
      ),
    },
  ];

    // Only logged-in users can access these routes
    routes.push(
      {
        // index: true,
        path: '/dashboard',
        elem: (
          <Page>
            {/* {!Environment.isEnvironment(ENVIRONMENT_TYPE.PROD) && <DevHeader />} */}
            {/* PF: Forcing a complete redraw when we re-hit this route */}
            <PlayerDashboard key={Date.now()} />
          </Page>
        ),
      },

      // { path: '/', render: () => <Redirect to="/dashboard" /> },
      { path: '/', elem: <Navigate to="/dashboard" /> },

      // Intros
      ...Content.getAllChapters().map((chapter, index) => {
        return {
          path: `/chapter/${chapter.chapterIdentifier}/intro`,
          elem: (
            <Page>
              <PlayerDashboard showingChapterIdentifier={chapter.chapterIdentifier} />
            </Page>
          ),
        };
      }),
      // Excercises
      ...Content.getAllChapters().map((chapter, index) => {
        return {
          path: `/chapter/${chapter.chapterIdentifier}`,
          elem: (
            <Page key={index}>
              <Chapter chapter={chapter} />
            </Page>
          ),
        };
      }),
      // Summaries
      ...Content.getAllChapters().map((chapter) => {
        return {
          path: `/chapter/${chapter.chapterIdentifier}/summary`,
          elem: (
            <Page>
              <StrategySummary chapter={chapter} />
            </Page>
          ),
        };
      }),      
      // access the support services from the dash
      {
        path: '/support-services',
        elem: (
          <Page>
            <SupportServices />
          </Page>
        ),
      },
     
    );

    if (IS_CHAT_BOT_ENABLED) {
      // ChatMate
      routes.push({
        path: '/chat-mate',
        elem: (
          <Page>
            <ChatMate />
          </Page>
        ),
      });
    }
  

  // eslint-disable-next-line no-console
  console.log('Routes: ', routes);

  return routes;
};
